/* ============================================================================
   Modern header — floating capsule behaviour
   - condenses the capsule as soon as the page leaves the top
   - slides a pill behind the hovered / focused / active top-level menu item
   No dependencies. Safe to load on every page; it exits when the header is
   running in classic mode.
============================================================================ */
(function () {
  'use strict';

  var teardown = null;

  function init() {
    if (teardown) teardown();
    teardown = null;

    var header = document.querySelector('.site-header--modern');
    if (!header) return;

    teardown = setup(header);
  }

  function setup(header) {
    var nav = header.querySelector('[data-nav]');
    var pill = header.querySelector('[data-nav-pill]');
    var CONDENSE_AT = 12;
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ------------------------------------------------------------- scroll -- */
    var ticking = false;

    function readScroll() {
      ticking = false;

      var top = window.pageYOffset || document.documentElement.scrollTop || 0;
      header.classList.toggle('is-condensed', top > CONDENSE_AT);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(readScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    readScroll();

    /* Logo mode "scroll": one spin the first time the capsule condenses. */
    var logo = header.querySelector('.kx-logo--scroll');
    if (logo) {
      var spun = false;
      var spinOnCondense = function () {
        if (spun || !header.classList.contains('is-condensed')) return;
        spun = true;
        logo.classList.add('is-spinning');
        setTimeout(function () { logo.classList.remove('is-spinning'); spun = false; }, 900);
      };
      window.addEventListener('scroll', spinOnCondense, { passive: true });
    }

    var cleanup = [
      function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (logo) window.removeEventListener('scroll', spinOnCondense);
      },
    ];

    function dispose() {
      cleanup.forEach(function (fn) {
        fn();
      });
    }

    /* --------------------------------------------------------------- pill -- */
    if (!nav || !pill) return dispose;

    var activeLink = nav.querySelector('.menu-item--active > .navlink--toplevel');

    function hidePill() {
      pill.classList.remove('is-visible');
    }

    function movePill(link) {
      if (!link || nav.classList.contains('nav--compress')) return hidePill();

      var linkRect = link.getBoundingClientRect();
      if (!linkRect.width) return hidePill();

      var navRect = nav.getBoundingClientRect();
      var wasHidden = !pill.classList.contains('is-visible');

      // Appearing from nothing must not look like a slide in from the left edge.
      if (wasHidden || reduceMotion) {
        pill.classList.add('is-instant');
      }

      pill.style.setProperty('--pill-x', Math.round(linkRect.left - navRect.left) + 'px');
      pill.style.setProperty('--pill-w', Math.round(linkRect.width) + 'px');
      pill.classList.add('is-visible');

      if (wasHidden || reduceMotion) {
        // Force a reflow so the next move animates from the position just set.
        void pill.offsetWidth;
        if (!reduceMotion) pill.classList.remove('is-instant');
      }
    }

    function restPill() {
      if (activeLink) {
        movePill(activeLink);
      } else {
        hidePill();
      }
    }

    var items = nav.querySelectorAll('[data-nav-item]');
    Array.prototype.forEach.call(items, function (item) {
      var link = item.querySelector('.navlink--toplevel');
      if (!link) return;

      item.addEventListener('mouseenter', function () {
        movePill(link);
      });
      link.addEventListener('focus', function () {
        movePill(link);
      });
    });

    nav.addEventListener('mouseleave', restPill);
    nav.addEventListener('focusout', function (event) {
      if (!nav.contains(event.relatedTarget)) restPill();
    });

    window.addEventListener('resize', restPill, { passive: true });
    window.addEventListener('load', restPill);
    document.addEventListener('theme:resize:width', restPill);
    restPill();

    cleanup.push(function () {
      window.removeEventListener('resize', restPill);
      window.removeEventListener('load', restPill);
      document.removeEventListener('theme:resize:width', restPill);
    });

    return dispose;
  }

  init();

  /* The theme editor re-renders the whole section on every settings change,
     which throws away the nodes these listeners are bound to. */
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || event.target.querySelector('.site-header--modern')) init();
  });
})();
